import { Button, Divider, List, Modal } from '@mairistem/composants';
import React from 'react';
import type ImputationHorsEspace from '../../../interfaces/simulation/imputationHorsEspace';
import type ImputationNonTrouvee from '../../../interfaces/simulation/imputationNonTrouvee';
import type ServiceNonHabilite from '../../../interfaces/simulation/serviceNonHabilite';
import {
	getGroupesLignesNonImportees,
	getLibelleImputationNonTrouvee,
	getLibelleServiceNonHabilite,
	getResumeServicesNonHabilites,
} from '../../../utils/simulation/rapportImputationsNonTrouvees';
import RapportJob from './RapportJob';

interface RapportImputationsNonTrouveesProps {
	anneeExercice?: number;
	imputations: ImputationNonTrouvee[];
	// Lignes dont le service n'a aucun espace contenant l'imputation (import APCP seulement)
	imputationsHorsEspace?: ImputationHorsEspace[];
	onClose: () => void;
	// Restes a realiser repris sur "Aucun service" (reprise des RAR seulement)
	servicesNonHabilites?: ServiceNonHabilite[];
	// Premiere ligne du rapport, par exemple "Import effectué."
	traitement: string;
}

const getItemsImputations = (imputations: ImputationNonTrouvee[]) =>
	imputations.map((imputation, index) => ({
		content: getLibelleImputationNonTrouvee(imputation),
		// Une meme ProImputation peut etre ignoree plusieurs fois (RAR)
		key: `${imputation.identifiantProImputation}-${index}`,
	}));

/**
 * Contenu de modal listant, par motif, les lignes APCP ignorees par un
 * traitement long et, pour la reprise des RAR, les restes a realiser repris
 * sur "Aucun service"
 */
const RapportImputationsNonTrouvees = ({
	anneeExercice,
	imputations,
	imputationsHorsEspace = [],
	onClose,
	servicesNonHabilites = [],
	traitement,
}: RapportImputationsNonTrouveesProps) => (
	<>
		<Modal.Content>
			<RapportJob resume={traitement} testIdResume="resumeTraitement" />
			{getGroupesLignesNonImportees(
				imputations,
				imputationsHorsEspace,
				anneeExercice,
			).map((groupe) => (
				// Un trait avant chaque motif : le detail deplie ne colle pas au
				// resume suivant
				<React.Fragment key={groupe.motif}>
					<Divider />
					<RapportJob
						resume={groupe.resume}
						testIdResume={`resume-${groupe.motif}`}
						titreDetail="Détail des lignes non importées"
					>
						<List bulleted items={getItemsImputations(groupe.lignes)} />
					</RapportJob>
				</React.Fragment>
			))}
			{servicesNonHabilites.length > 0 && (
				<>
					<Divider />
					<RapportJob
						resume={getResumeServicesNonHabilites(servicesNonHabilites)}
						testIdResume="resumeServicesNonHabilites"
						titreDetail="Détail des restes à réaliser repris sur « Aucun service »"
					>
						<List
							bulleted
							items={servicesNonHabilites.map((service) => ({
								content: getLibelleServiceNonHabilite(service),
								// Une ligne peut avoir plusieurs services non habilites
								key: `${service.identifiantImputation}-${service.identifiantSvutCpta}`,
							}))}
						/>
					</RapportJob>
				</>
			)}
		</Modal.Content>
		<Modal.Actions>
			<Button
				content="Fermer"
				data-testid="closeRapportButton"
				onClick={onClose}
			/>
		</Modal.Actions>
	</>
);

export default RapportImputationsNonTrouvees;
